import React from "react";
import ConfigSection from "../../ConfigSection";

const SubVendorTypeSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Sub Vendor Type'
      configType='SubVendorType'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default SubVendorTypeSection;
